"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montanaso-lombardo": {
    "40a6b94c": [{
      "hkey": "13d72143",
      "slug": "belgiardino",
      "name": "Belgiardino",
      "primary": true,
      "skipSearch": false
    }],
    "begiardino": [{
      "hkey": "13d72143",
      "slug": "belgiardino",
      "name": "Belgiardino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "98e430fb": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0840786f": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "ca-de-cani": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3019da9b": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "case-nuove": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8adc052c": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "colombera": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a7344882": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "gamorra": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a20d583": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "lazzara": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f1cf77c": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "mazzucca": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "253f40ce": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "palazzo": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6d598ef3": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "skipSearch": false
    }],
    "pizzafuma-e-pizzafuma-nuova": [{
      "hkey": "e1c98c9d",
      "slug": "montanaso-lombardo",
      "name": "Montanaso Lombardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;